export default {
  mapEmbed: 'https://www.google.com/maps/embed/v1/place?key=AIzaSyBZK-UhBz5bpS5PA6Clwv6C2Yo-SxQG6Rk',
}
